/* eslint-disable max-classes-per-file */
class RuutsError extends Error {
  request: unknown

  response: unknown

  unexpected: boolean

  needSupport: boolean

  status?: number

  constructor({ request, response, message, unexpected, needSupport, status }) {
    super(message)
    this.request = request
    this.response = response
    this.unexpected = unexpected
    this.needSupport = needSupport
    this.status = status
  }
}

class BusinessEntityError extends RuutsError {
  constructor({
    request = undefined,
    message,
    response = undefined,
    needSupport,
    status = undefined,
  }) {
    super({
      request,
      message,
      unexpected: false,
      response,
      needSupport,
      status,
    })
  }
}

class UnexpectedEntityError extends RuutsError {
  constructor({ request = undefined, message, status = undefined }) {
    super({
      request,
      response: undefined,
      message,
      unexpected: true,
      needSupport: true,
      status,
    })
  }
}

export const errors = {
  RuutsError,
  BusinessEntityError,
  UnexpectedEntityError,
}

const GATEWAY_STATUSES = [502, 503, 504]

// True for no response (status-less) or a gateway/proxy status, where the API may have committed.
// An API 500 is excluded: it answers from its catch after the transaction rolled back.
export const isWriteOutcomeUnknown = (error: unknown): boolean =>
  error instanceof UnexpectedEntityError &&
  (error.status === undefined || GATEWAY_STATUSES.includes(error.status))
